import {
  ArrowVertical,
  Palette,
  UnorderedList,
  Pen,
  Image,
  Preview,
  Link
} from 'wix-style-react/dist/src/Icons'

export const OPEN = {type: 'open', label: 'Open', icon: ArrowVertical}
export const DESIGN = {type: 'design', label: 'Design', icon: Palette}
export const PRODUCTS = {type: 'product', label: 'Products', icon: UnorderedList}
export const EDIT_TEXT = {type: 'editText', label: 'Edit text', icon: Pen}
export const EDIT_URL = {type: 'editUrl', label: 'Edit URL', icon: Link}
export const EDIT_EMAIL = {type: 'editEmail', label: 'Edit Email', icon: Preview}
export const ASSETS = {type: 'assets', label: 'Assets', icon: Image}
export const EDIT_LAYOUT = {type: 'editLayout', label: 'Edit layout', icon: UnorderedList}
export const EDIT_SOCIAL = {type: 'editSocial', label: 'Edit Link', icon: Link}
export const CHOOSE_TYPE = {type: 'chooseType', label: 'Choose block type', icon: UnorderedList}



// WEBPACK FOOTER //
// ./src/constants/fieldMenuButtonTypes.js